import { combineReducers } from 'redux';

import completedReviews from './completedReviews';

export default combineReducers({ completedReviews });

export const selectCompletedReviews = state => state.completedReviews;
